module.exports = __webpack_public_path__ + "8d0700d9814a8fa9f1debe1253af0cad.MP3";